module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.comeFrom) ? _c('div', {
    staticClass: "coupons-container"
  }, [_c('div', {
    staticClass: "header-subtitle"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.availableCoupons ? _vm.availableCoupons.length : 0) + "张可用优惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "coupon-content",
    style: ({
      'bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [(_vm.displayAllCoupons.length > 0) ? _c('div', _vm._l((_vm.displayAllCoupons), function(coupon, index) {
    return _c('div', {
      staticClass: "select-coupon"
    }, [_c('div', {
      staticClass: "coupon",
      style: (_vm.getCouponStyle(coupon))
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.getCouponEnabled(coupon)),
        expression: "!getCouponEnabled(coupon)"
      }],
      staticClass: "coupon-unuse",
      attrs: {
        "src": "static/img/不可用.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "coupon-detail"
    }, [_c('div', {
      staticClass: "detail-content"
    }, [_c('span', {
      style: ({
        'font-size': '14px',
        'color': _vm.getCouponEnabled(coupon) ? '#68533D' : '#979797'
      })
    }, [_vm._v(_vm._s(coupon.label))]), _vm._v(" "), _c('span', {
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v(_vm._s(coupon.typeName) + " " + _vm._s(_vm.getCouponDisabledText(coupon)))]), _vm._v(" "), _c('span', {
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v("有效期至" + _vm._s(coupon.endDT))])]), _vm._v(" "), (coupon.type === _vm.emkt.COUPON_TYPE_DISCOUNT) ? _c('div', {
      staticClass: "detail-discount"
    }, [_c('span', {
      style: (_vm.getCouponValueStyle(coupon))
    }, [_vm._v(_vm._s(_vm.getCouponDiscount(coupon)))]), _vm._v("折")]) : (![_vm.emkt.COUPON_TYPE.prepaySpecialFundCoupon, _vm.emkt.COUPON_TYPE_NEW_DISCOUNT].includes(coupon.type)) ? _c('div', {
      staticClass: "detail-discount"
    }, [_c('span', {
      style: (_vm.getCouponValueStyle(coupon))
    }, [_vm._v(_vm._s(coupon.value))]), _vm._v("元")]) : _vm._e()]), _vm._v(" "), _c('object', {
      staticClass: "left-circle",
      attrs: {
        "data": _vm.getLeftCirclePath(coupon),
        "type": "image/svg+xml"
      }
    }), _vm._v(" "), _c('object', {
      staticClass: "right-circle",
      attrs: {
        "data": _vm.getRightCirclePath(coupon),
        "type": "image/svg+xml"
      }
    }), _vm._v(" "), _c('hr', {
      staticClass: "coupon-split",
      style: ({
        'border-color': _vm.getCouponEnabled(coupon) ? '#FFFFFF' : '#EFEEF3'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "coupon-rule"
    }, [_c('div', {
      staticClass: "use-rule",
      on: {
        "click": function($event) {
          return _vm.toggleShowRule(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "10px"
      },
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v("使用规则")]), _vm._v(" "), (!_vm.couponShowRule[index]) ? _c('i', {
      staticClass: "icon-font emkt-icon-zhankai",
      style: (_vm.getUnavailableStyle(coupon))
    }) : _vm._e(), _vm._v(" "), (_vm.couponShowRule[index]) ? _c('i', {
      staticClass: "icon-font emkt-icon-shouqi",
      style: (_vm.getUnavailableStyle(coupon))
    }) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentExcluded(coupon)),
        expression: "currentExcluded(coupon)"
      }],
      staticClass: "alert-text",
      staticStyle: {
        "margin-left": "10px",
        "z-index": "10"
      }
    }, [_vm._v("与已选择优惠券互斥")])]), _vm._v(" "), (_vm.couponShowRule[index]) ? _c('div', {
      staticStyle: {
        "padding-bottom": "11px"
      },
      style: (_vm.getUnavailableStyle(coupon))
    }, _vm._l((coupon.desc), function(items, indexs) {
      return _c('div', [_vm._v("\n                " + _vm._s(indexs + 1) + "、" + _vm._s(items) + "。\n                ")])
    }), 0) : _vm._e()])]), _vm._v(" "), _c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.chosenCoupons),
        expression: "chosenCoupons"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.checkBoxIsDisabled(coupon),
        "name": "couponCheckbox"
      },
      domProps: {
        "value": coupon,
        "checked": Array.isArray(_vm.chosenCoupons) ? _vm._i(_vm.chosenCoupons, coupon) > -1 : (_vm.chosenCoupons)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.chosenCoupons,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = coupon,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.chosenCoupons = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.chosenCoupons = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.chosenCoupons = $$c
          }
        }, function($event) {
          return _vm.handleSelectionChange(coupon)
        }]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-media group"
    }, [_c('i', {
      staticClass: "icon icon-form-checkbox i-style",
      style: ({
        'border-color': _vm.checkBoxIsDisabled(coupon) ? '#D9D9D9' : '#979797'
      })
    })])])])
  }), 0) : _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-top": "50px"
    },
    attrs: {
      "src": "/static/img/优惠券空.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("已选择"), _c('span', {
    staticClass: "alert-text"
  }, [_vm._v(_vm._s(_vm.chosenCoupons.length))]), _vm._v("张优惠券")]), _vm._v(" "), (_vm.availableCoupons.length > 0) ? _c('div', {
    staticClass: "pay-btn research-background-color",
    on: {
      "click": _vm.confirmCoupon
    }
  }, [_vm._v("确认使用")]) : _c('div', {
    staticClass: "pay-btn",
    staticStyle: {
      "background-color": "#979797"
    }
  }, [_vm._v("确认使用")])]), _vm._v(" "), _c('footer-placeholder')], 1)]) : _c('div', {
    staticClass: "coupons-container"
  }, [_c('div', {
    staticClass: "coupon-content",
    style: ({
      'bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [(_vm.myAllCoupons.length > 0) ? _c('div', _vm._l((_vm.myAllCoupons), function(coupon, index) {
    return _c('div', {
      staticClass: "select-coupon"
    }, [_c('div', {
      staticClass: "coupon-full",
      style: (_vm.getCouponStyle(coupon))
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!coupon.available),
        expression: "!coupon.available"
      }],
      staticClass: "coupon-unuse-full",
      attrs: {
        "src": "static/img/已过期.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "coupon-detail"
    }, [_c('div', {
      staticClass: "detail-content"
    }, [_c('span', {
      style: ({
        'font-size': '14px',
        'color': _vm.getCouponEnabled(coupon) ? '#68533D' : '#979797'
      })
    }, [_vm._v(_vm._s(coupon.label))]), _vm._v(" "), _c('span', {
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v(_vm._s(coupon.typeName) + " " + _vm._s(_vm.getCouponDisabledText(coupon)))]), _vm._v(" "), _c('span', {
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v("有效期至" + _vm._s(coupon.endDT))])]), _vm._v(" "), (coupon.type === _vm.emkt.COUPON_TYPE_DISCOUNT) ? _c('div', {
      staticClass: "detail-discount"
    }, [_c('span', {
      style: (_vm.getCouponValueStyle(coupon))
    }, [_vm._v(_vm._s(_vm.getCouponDiscount(coupon)))]), _vm._v("折")]) : (![_vm.emkt.COUPON_TYPE.prepaySpecialFundCoupon, _vm.emkt.COUPON_TYPE_NEW_DISCOUNT].includes(coupon.type)) ? _c('div', {
      staticClass: "detail-discount"
    }, [_c('span', {
      style: (_vm.getCouponValueStyle(coupon))
    }, [_vm._v(_vm._s(coupon.value))]), _vm._v("元")]) : _vm._e()]), _vm._v(" "), _c('object', {
      staticClass: "left-circle",
      attrs: {
        "data": _vm.getLeftCirclePath(coupon),
        "type": "image/svg+xml"
      }
    }), _vm._v(" "), _c('object', {
      staticClass: "right-circle",
      attrs: {
        "data": _vm.getRightCirclePath(coupon),
        "type": "image/svg+xml"
      }
    }), _vm._v(" "), _c('hr', {
      staticClass: "coupon-split",
      style: ({
        'border-color': _vm.getCouponEnabled(coupon) ? '#FFFFFF' : '#EFEEF3'
      })
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "10px",
        "float": "right"
      }
    }, [(_vm.getCouponEnabled(coupon) && coupon.isPresent === 1) ? _c('span', {
      staticClass: "small-font-set1",
      on: {
        "click": function($event) {
          return _vm.showPresentCouponDialog(coupon)
        }
      }
    }, [_vm._v("\n          转赠\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getCouponEnabled(coupon)) ? _c('span', {
      staticClass: "small-font-set",
      on: {
        "click": _vm.jumpTo
      }
    }, [_vm._v("\n          立即使用\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "coupon-rule"
    }, [_c('div', {
      staticClass: "use-rule",
      on: {
        "click": function($event) {
          return _vm.toggleShowRule(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "10px"
      },
      style: (_vm.getUnavailableStyle(coupon))
    }, [_vm._v("使用规则")]), _vm._v(" "), (!_vm.couponShowRule[index]) ? _c('i', {
      staticClass: "icon-font emkt-icon-zhankai",
      style: (_vm.getUnavailableStyle(coupon))
    }) : _vm._e(), _vm._v(" "), (_vm.couponShowRule[index]) ? _c('i', {
      staticClass: "icon-font emkt-icon-shouqi",
      style: (_vm.getUnavailableStyle(coupon))
    }) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentExcluded(coupon)),
        expression: "currentExcluded(coupon)"
      }],
      staticClass: "alert-text",
      staticStyle: {
        "margin-left": "10px",
        "z-index": "10"
      }
    }, [_vm._v("与已选择优惠券互斥")])]), _vm._v(" "), (_vm.couponShowRule[index]) ? _c('div', {
      staticStyle: {
        "padding-bottom": "11px"
      },
      style: (_vm.getUnavailableStyle(coupon))
    }, _vm._l((coupon.desc), function(items, indexs) {
      return _c('div', [_vm._v("\n                  " + _vm._s(indexs + 1) + "、" + _vm._s(items) + "。\n                ")])
    }), 0) : _vm._e()])])])
  }), 0) : _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-top": "50px"
    },
    attrs: {
      "src": "/static/img/优惠券空.png"
    }
  })])])]), _vm._v(" "), (_vm.showPresentCoupon) ? _c('div', {
    staticClass: "background-modal",
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPresentCoupon),
      expression: "showPresentCoupon"
    }],
    staticClass: "choose-pay-method"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "32px",
      "width": "32px"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    staticClass: "icon4",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "/static/img/关闭.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPresentCoupon),
      expression: "showPresentCoupon"
    }]
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "flex-start"
    }
  }, [_c('div', {
    staticClass: "deep-text-color",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.receiverCustomerName),
      expression: "receiverCustomerName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "verity-info",
    attrs: {
      "type": "text",
      "placeholder": "请输入被转赠人的姓名"
    },
    domProps: {
      "value": (_vm.receiverCustomerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.receiverCustomerName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "flex-start"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "deep-text-color",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.receiverCustomerMobile),
      expression: "receiverCustomerMobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "verity-info",
    attrs: {
      "type": "text",
      "placeholder": "请输入被转赠人的手机号"
    },
    domProps: {
      "value": (_vm.receiverCustomerMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.receiverCustomerMobile = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "pay-btn research-background-color",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.transferCoupon
    }
  }, [_vm._v("确定")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("转赠优惠券")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remind-info light-text-color"
  }, [_c('span', {
    staticClass: "alert-text"
  }, [_vm._v("转赠优惠券之前，请先提醒被转赠人注册淘基因账户，否则无法使用转赠功能")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03f4f560","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Order/CouponSelection.vue
// module id = 1523
// module chunks = 8